import React from "react";
import style from "./index.module.css";

interface SchoolCampaignReminderProps {
  joinSC: boolean;
}

const SchoolCampaignReminder: React.FC<SchoolCampaignReminderProps> = ({
  joinSC,
}) => {
  const isSchoolCampaignPage = (window.parent as any).location.href.includes(
    "tradSchoolCampaign"
  );

  if (!joinSC || isSchoolCampaignPage) {
    return null;
  }

  return (
    <p className={style.reminder}>
      ↑此盤別非「校園課程」，欲進行校園課程競賽，請切換至
      「校園課程專區」。
    </p>
  );
};

export default SchoolCampaignReminder;
